import { DefaultService } from '@/services/DefaultService';

export default class ConfigSmtpService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    find() {
        return this._http.get(`${this._env}/config/smtp`, this._headers)
            .then(res => res.body, this.handleError);
    }

    save(config) {
        return this._http.post(`${this._env}/config/smtp`, config, this._headers)
            .then(res => res.body, this.handleError);
    }

    test(config) {
        return this._http.post(`${this._env}/config/smtp/test`, config, this._headers)
            .then(res => res.body, this.handleError);
    }

}